module.exports = __webpack_public_path__ + "img/remitaccountphoto.dca92d6d.jpg";